import * as React from "react";
import TopPerformers from "./TopPerformers";
import NonParticipants from "./NonParticipants";
import NeedsGuidance from "./NeedsGuidance";

const StudentStats = ({ excellentStudentList, inCompletedStudentList, filterInfoList, classStageStudentList }) => {
    return (
        <div className="mt-8 max-w-full w-[1044px]">
            <div className="flex gap-5 max-md:flex-col">
                <div className="flex flex-col w-[33%] h-[340px] max-md:ml-0 max-md:w-full">
                    <TopPerformers
                        excellentStudentList={excellentStudentList}
                    />
                </div>
                <div className="flex flex-col w-[33%] h-[340px] max-md:ml-0 max-md:w-full">
                    <NonParticipants
                        inCompletedStudentList={inCompletedStudentList}
                        classStageStudentList={classStageStudentList}
                    />
                </div>
                <div className="flex flex-col w-[33%] h-[340px]  max-md:ml-0 max-md:w-full">
                    <NeedsGuidance
                        filterInfoList={filterInfoList}
                    />
                </div>
            </div>
        </div>
    );
}

export default StudentStats;